import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'i2g-chat-header',
  templateUrl: 'chat-header.component.html',
  styleUrls: ['chat-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatHeaderComponent implements OnInit {
  @Input() title: string;
  @Input() name: string;

  constructor() {}

  ngOnInit() {}
}
